import { inject } from 'inversify';
import { urlMaker } from '@core/utils';
import { IRepo, IRepoResponse } from '@core/repo';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { bind } from '@infra/container';
import { FlyexLocationMapper } from '../mappers';
import { IFlyexLocation } from '../interfaces';

export type IGetFlyexLocationsRepoResponse = IRepoResponse<200, IFlyexLocation[]> | IRepoResponse<400 | 500, string>;

export type IGetFlyexLocationsRepo = IRepo<[], IGetFlyexLocationsRepoResponse>;

export const GetFlyexLocationsRepoType = Symbol.for('GetFlyexLocationsRepo');

@bind(GetFlyexLocationsRepoType)
export class GetFlyexLocationsRepo implements IGetFlyexLocationsRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute() {
    try {
      const result = await this.httpClient.get({ url: urlMaker('/api/admin/flyex/locations') });

      if (result.status === 200) {
        const data = result.data.data.map(FlyexLocationMapper.toDomain);

        return {
          status: 200 as 200,
          response: data,
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi',
      };
    }
  }
}
